import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { isNil, isNull } from 'lodash'
import moment from 'moment'
import { Button, Col, Form, Icon, Input, Row, Upload, DatePicker } from 'antd'
import { useDeepEffect } from '../../../../utils/hooks'
import {
  getBase64,
  validateUploadedImage,
  uploadBrandActivityImage
} from '../../../../utils/services'
import { disabledBeforeCurrentDate } from '../../../../utils/dateTime'
import { ACTION } from '../../../../utils/constants'

const { TextArea } = Input

const uploadButton = (
  <div>
    <Icon type="plus" />
    <div className="ant-upload-text">เพิ่มรูปภาพ</div>
  </div>
)

const initActivityConditions = [
  {
    id: 1,
    conditionDesc: 'คำนวนคะแนนกิจกรรมจาก Product ที่รองรับ',
    enabled: true
  },
  {
    id: 2,
    conditionDesc: 'คำนวนคะแนนกิจกรรมจาก Hero ที่รองรับ',
    enabled: true
  },
  {
    id: 3,
    conditionDesc: 'คำนวนคะแนนกิจกรรมจาก Hero Confirm',
    enabled: true
  },
  {
    id: 4,
    conditionDesc: 'แสดงคะแนนของกิจกรรมตามลำดับ',
    enabled: true
  }
]

const InfoFrom = (props) => {
  const { onOk, onCancel, form, action, formState } = props
  const { getFieldDecorator, validateFields } = form
  const [imageUrl, setImageUrl] = useState('')

  useDeepEffect(() => {
    if (!isNull(formState) && !isNil(formState)) {
      form.setFieldsValue({
        activityName: formState.activityName,
        activityDetail: formState.activityDetail,
        effectiveDate: moment(formState.effectiveDate),
        expirationDate: moment(formState.expirationDate),
        url: formState.url
      })
      setImageUrl(formState.image)
    }
    return () => {
      form.resetFields()
      setImageUrl('')
    }
  }, [formState])

  const onSubmit = (e) => {
    e.preventDefault()
    validateFields(async (err, values) => {
      if (!err) {
        let img = null
        const data = {
          activityName: values.activityName,
          activityDetail: values.activityDetail,
          effectiveDate: values.effectiveDate.toISOString(),
          expirationDate: values.expirationDate.toISOString(),
          image: values.image,
          activityConditions:
            action === ACTION.CREATE
              ? initActivityConditions
              : formState.activityConditions
        }

        if (values.image) {
          img = await uploadBrandActivityImage(values.image.file)
          data.image = img.url
        } else {
          data.image = formState.image
        }

        if (action === ACTION.UPDATE) {
          data.id = formState.id
        }

        await onOk(data)
        await form.resetFields()
        await setImageUrl('')
      }
    })
  }

  const handleChange = async (info) => {
    await getBase64(info.file, (imageUrl) => {
      setImageUrl(imageUrl)
    })
  }

  return (
    <Form name="formBrandActivity" onSubmit={onSubmit} layout="vertical">
      <Form.Item label="ชื่อกิจกรรม">
        {getFieldDecorator(`activityName`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<Input />)}
      </Form.Item>
      <Row type="flex" gutter={[8, 8]}>
        <Col span={10}>
          <Form.Item label="วันเริ่มกิจกรรม">
            {getFieldDecorator(`effectiveDate`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(<DatePicker disabledDate={disabledBeforeCurrentDate} />)}
          </Form.Item>
        </Col>
        <Col span={10}>
          <Form.Item label="วันสิ้นสุดกิจกรรม">
            {getFieldDecorator(`expirationDate`, {
              rules: [
                {
                  required: true,
                  message: 'กรุณากรอก'
                }
              ]
            })(<DatePicker disabledDate={disabledBeforeCurrentDate} />)}
          </Form.Item>
        </Col>
      </Row>
      <Form.Item label="รายละเอียดกิจกรรม">
        {getFieldDecorator(`activityDetail`, {
          rules: [
            {
              required: true,
              message: 'กรุณากรอก'
            }
          ]
        })(<TextArea autoSize={{ minRows: 4, maxRows: 10 }} allowClear />)}
      </Form.Item>
      <Form.Item label="รูปภาพกิจกรรม">
        {getFieldDecorator(`image`, {
          rules: [
            {
              required: isNull(formState),
              message: 'เพิ่มรูปภาพ'
            }
          ]
        })(
          <Upload
            name="avatar"
            listType="picture-card"
            showUploadList={false}
            beforeUpload={validateUploadedImage}
            onChange={handleChange}>
            {imageUrl ? (
              <img src={imageUrl} alt="avatar" style={{ width: '100%' }} />
            ) : (
              uploadButton
            )}
          </Upload>
        )}
      </Form.Item>
      <Row type="flex" justify="end" gutter={8}>
        <Col>
          <Button onClick={() => onCancel()} key="cancel" type="danger">
            ยกเลิก
          </Button>
        </Col>
        <Col>
          <Button
            name="formBrandActivity"
            key="submit"
            type="primary"
            htmlType="submit">
            บันทึก
          </Button>
        </Col>
      </Row>
    </Form>
  )
}

InfoFrom.propTypes = {
  action: PropTypes.string.isRequired,
  onOk: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  form: PropTypes.any.isRequired
}

const WrappedInfoFrom = Form.create({
  name: 'InfoFrom'
})(InfoFrom)
export default WrappedInfoFrom



// WEBPACK FOOTER //
// ./src/pages/BrandActivity/BrandActivityForm/InfoForm/index.js